function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: 24px;\n  width: 24px;\n  svg {\n    vertical-align: top;\n  }\n\n  &:focus {\n    background-color: ", ";\n    outline: none;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 40px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Flex, CloseButton, deprecatedPropType, Text } from 'pcln-design-system';
var HeaderWrapper = styled(Flex)(_templateObject());
var Title = styled(Text)(_templateObject2());
var StyledCloseButton = styled(CloseButton)(_templateObject3(), function (props) {
  return props.theme.palette.primary.dark;
});

var ModalHeader = function ModalHeader(_ref) {
  var bg = _ref.bg,
      color = _ref.color,
      onClose = _ref.onClose,
      title = _ref.title;
  return /*#__PURE__*/React.createElement(HeaderWrapper, {
    align: "center",
    alignItems: "center",
    color: color,
    bg: bg,
    px: 3
  }, title && /*#__PURE__*/React.createElement(Title, {
    fontSize: 1,
    bold: true
  }, title), onClose && /*#__PURE__*/React.createElement(StyledCloseButton, {
    onClick: onClose,
    ml: "auto"
  }));
};

ModalHeader.displayName = ModalHeader;
ModalHeader.propTypes = {
  bg: deprecatedPropType('color'),
  onClose: PropTypes.func,
  color: PropTypes.string,
  title: PropTypes.string
};
ModalHeader.defaultProps = {
  bg: 'blue',
  color: 'white'
};
export default ModalHeader;